import { Box, Button, Flex } from '@chakra-ui/react';

import { SegmentedControls } from '../SegmentedControls';

export const BooleanFilter = ({
    filterValue,
    setFilterValue,
    allowClear,
}: {
    filterValue: boolean | undefined;
    setFilterValue: (value?: string) => void;
    allowClear?: boolean;
}) => {
    return (
        <Flex gap={2}>
            <Box width="200px">
                <SegmentedControls
                    stretch
                    variant="solid"
                    size="xs"
                    options={[
                        { label: 'True', value: 'true' },
                        { label: 'False', value: 'false' },
                    ]}
                    onClick={setFilterValue}
                    selectedValue={String(filterValue)}
                />
            </Box>
            {allowClear && filterValue !== undefined && (
                <Button colorScheme="teal" size="xs" variant="ghost" onClick={() => setFilterValue(undefined)}>
                    clear
                </Button>
            )}
        </Flex>
    );
};
